import * as types from '../constants/ActionTypes-privilegeParty';

// Definir el estado inicial
const initialState = {
  itemPartys: [], // Inicialmente vacío
  loading: false,
  error: null,
};

// Definir el reducer
const privilegePartyReducer = (state = initialState, action) => {
    if (action.reducer_type === 'reducer_privilege') {    
        switch (action.type) {
            case types.SET_ELEMENT_PARTY:
            return {
                ...state,
                itemPartys: action.payload,
            };                    
        }
    }
    return state;
};

export default privilegePartyReducer;